import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import {
  Settings,
  CreditCard,
  Mail,
  Phone,
  DollarSign,
  Globe,
  Link2,
  Bell,
  MessageSquare,
  Bot,
  Landmark,
  Save,
  Loader2
} from 'lucide-react';

import CommonFormComponent from '../../CommonField/CommonFormComponent';
import submit from './submit';
import validate from './validate';
import messages from '../../../locale/messages';

import s from './ConfigSettingsForm.css';
class ConfigSettingsForm extends React.Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
  };


  render() {
    const { error, handleSubmit, submitting } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={s.pageContainer}>
        {/* Page Header */}
        <div className={s.pageHeader}>
          <h1 className={s.pageTitle}>
            <div className={s.pageTitleIcon}>
              <Settings size={24} />
            </div>
            <FormattedMessage {...messages.manageSiteConfig} />
          </h1>
          <p className={s.pageSubtitle}>
            Configure payment gateways, email settings, and third-party integrations
          </p>
        </div>

        <form onSubmit={handleSubmit(submit)}>
          {error && <div className="alert alert-danger">{error}</div>}

          {/* Stripe Settings */}
          <div className={s.sectionCard}>
            <div className={s.sectionHeader}>
              <div className={cx(s.sectionHeaderIcon, s.sectionHeaderIconBlue)}>
                <CreditCard size={18} />
              </div>
              <h3 className={s.sectionTitle}>{formatMessage(messages.stripeSettings)}</h3>
            </div>
            <div className={s.sectionBody}>
              <div className={s.girdOne}>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.stripePublishableKey} /></label>
                  <Field name="stripePublishableKey" type="text" component={CommonFormComponent} label={formatMessage(messages.stripePublishableKey)} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.maxUploadLabel} /></label>
                  <Field name="maxUploadSize" type="text" component={CommonFormComponent} label={formatMessage(messages.maxUploadLabel)} />
                </div>
              </div>
            </div>
          </div>

          {/* SMTP Settings */}
          <div className={s.sectionCard}>
            <div className={s.sectionHeader}>
              <div className={cx(s.sectionHeaderIcon, s.sectionHeaderIconGreen)}>
                <Mail size={18} />
              </div>
              <h3 className={s.sectionTitle}>{formatMessage(messages.smtpSettings)}</h3>
            </div>
            <div className={s.sectionBody}>
              <div className={s.girdTwo}>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.smtpHost} /></label>
                  <Field name="smtpHost" type="text" component={CommonFormComponent} label={formatMessage(messages.smtpHost)} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.smtpPort} /></label>
                  <Field name="smtpPort" type="text" component={CommonFormComponent} label={formatMessage(messages.smtpPort)} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.smptEmail} /></label>
                  <Field name="smptEmail" type="text" component={CommonFormComponent} label={formatMessage(messages.smptEmail)} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.smtpSender} /></label>
                  <Field name="smtpSender" type="text" component={CommonFormComponent} label={formatMessage(messages.smtpSender)} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.smtpSenderEmail} /></label>
                  <Field name="smtpSenderEmail" type="text" component={CommonFormComponent} label={formatMessage(messages.smtpSenderEmail)} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.smtpPassWord} /></label>
                  <Field name="smtpPassWord" type="text" component={CommonFormComponent} label={formatMessage(messages.smtpPassWord)} />
                </div>
              </div>
            </div>
          </div>

          {/* Twilio Settings */}
          <div className={s.sectionCard}>
            <div className={s.sectionHeader}>
              <div className={cx(s.sectionHeaderIcon, s.sectionHeaderIconOrange)}>
                <Phone size={18} />
              </div>
              <h3 className={s.sectionTitle}>{formatMessage(messages.twillioSettings)}</h3>
            </div>
            <div className={s.sectionBody}>
              <div className={s.girdTwo}>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.twillioAccountSid} /></label>
                  <Field name="twillioAccountSid" type="text" component={CommonFormComponent} label={formatMessage(messages.twillioAccountSid)} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.twillioAuthToken} /></label>
                  <Field name="twillioAuthToken" type="text" component={CommonFormComponent} label={formatMessage(messages.twillioAuthToken)} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.twillioPhone} /></label>
                  <Field name="twillioPhone" type="text" component={CommonFormComponent} label={formatMessage(messages.twillioPhone)} />
                </div>
              </div>
            </div>
          </div>

          {/* PayPal Settings */}
          <div className={s.sectionCard}>
            <div className={s.sectionHeader}>
              <div className={cx(s.sectionHeaderIcon, s.sectionHeaderIconBlue)}>
                <DollarSign size={18} />
              </div>
              <h3 className={s.sectionTitle}>{formatMessage(messages.paypalSettings)}</h3>
            </div>
            <div className={s.sectionBody}>
              <div className={s.girdTwo}>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.paypalClientId} /></label>
                  <Field name="paypalClientId" type="text" component={CommonFormComponent} label={formatMessage(messages.paypalClientId)} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.paypalSecret} /></label>
                  <Field name="paypalSecret" type="text" component={CommonFormComponent} label={formatMessage(messages.paypalSecret)} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.paypalHost} /></label>
                  <Field name="paypalHost" type="text" component={CommonFormComponent} label={formatMessage(messages.paypalHost)} />
                </div>
              </div>
            </div>
          </div>

          {/* Google Settings */}
          <div className={s.sectionCard}>
            <div className={s.sectionHeader}>
              <div className={cx(s.sectionHeaderIcon, s.sectionHeaderIconGreen)}>
                <Globe size={18} />
              </div>
              <h3 className={s.sectionTitle}>{formatMessage(messages.googleSettings)}</h3>
            </div>
            <div className={s.sectionBody}>
              <div className={s.girdOne}>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.googleClientId} /></label>
                  <Field name="googleClientId" type="text" component={CommonFormComponent} label={formatMessage(messages.googleClientId)} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.googleSecretId} /></label>
                  <Field name="googleSecretId" type="text" component={CommonFormComponent} label={formatMessage(messages.googleSecretId)} />
                </div>
              </div>
            </div>
          </div>

          {/* Deep Link Settings */}
          <div className={s.sectionCard}>
            <div className={s.sectionHeader}>
              <div className={cx(s.sectionHeaderIcon, s.sectionHeaderIconPurple)}>
                <Link2 size={18} />
              </div>
              <h3 className={s.sectionTitle}>{formatMessage(messages.deepLinkSettings)}</h3>
            </div>
            <div className={s.sectionBody}>
              <div className={s.girdOne}>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.deepLinkBundleId} /></label>
                  <Field name="deepLinkBundleId" type="text" component={CommonFormComponent} label={formatMessage(messages.deepLinkBundleId)} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}><FormattedMessage {...messages.deepLinkContent} /></label>
                  <Field name="deepLinkContent" component={CommonFormComponent} label={formatMessage(messages.deepLinkContent)} componentClass={"textarea"} />
                </div>
              </div>
            </div>
          </div>

          {/* Push Notification Settings */}
          <div className={s.sectionCard}>
            <div className={s.sectionHeader}>
              <div className={cx(s.sectionHeaderIcon, s.sectionHeaderIconOrange)}>
                <Bell size={18} />
              </div>
              <h3 className={s.sectionTitle}>{formatMessage(messages.pushNotificationSettings)}</h3>
            </div>
            <div className={s.sectionBody}>
              <div className={s.formGroup}>
                <label className={s.formLabel}><FormattedMessage {...messages.fcmPushNotificationKey} /></label>
                <Field name="fcmPushNotificationKey" component={CommonFormComponent} label={formatMessage(messages.fcmPushNotificationKey)} componentClass={"textarea"} />
              </div>
            </div>
          </div>

          {/* Live Chat Settings */}
          <div className={s.sectionCard}>
            <div className={s.sectionHeader}>
              <div className={cx(s.sectionHeaderIcon, s.sectionHeaderIconGreen)}>
                <MessageSquare size={18} />
              </div>
              <h3 className={s.sectionTitle}>Live Chat Settings</h3>
            </div>
            <div className={s.sectionBody}>
              <div className={s.girdOne}>
                <div className={s.formGroup}>
                  <label className={s.formLabel}>Show Live Chat</label>
                  <Field
                    name="showchat"
                    component={({ input }) => {
                      const isChecked = input.value === true || input.value === 'true' || input.value === 1 || input.value === '1';
                      return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <label className={s.toggleSwitch}>
                            <input type="checkbox" checked={isChecked} onChange={(e) => input.onChange(e.target.checked)} />
                            <span className={s.slider}></span>
                          </label>
                          <span style={{ color: isChecked ? '#10B981' : '#EF4444', fontWeight: 500, fontSize: 14 }}>
                            {isChecked ? 'Enabled' : 'Disabled'}
                          </span>
                        </div>
                      );
                    }}
                  />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}>Live Chat Script</label>
                  <Field name="livechat" component={CommonFormComponent} label={"Live chat Script"} componentClass={"textarea"} />
                </div>
              </div>
            </div>
          </div>

          {/* AI Translation Settings */}
          <div className={s.sectionCard}>
            <div className={s.sectionHeader}>
              <div className={cx(s.sectionHeaderIcon, s.sectionHeaderIconPurple)}>
                <Bot size={18} />
              </div>
              <h3 className={s.sectionTitle}>AI Translation Settings (OpenAI)</h3>
            </div>
            <div className={s.sectionBody}>
              <div className={s.formGroup} style={{ maxWidth: 400 }}>
                <label className={s.formLabel}>OpenAI API Key</label>
                <Field name="openaiApiKey" type="password" component={CommonFormComponent} label="OpenAI API Key (sk-...)" />
              </div>
            </div>
          </div>

          {/* Megasoft Settings */}
          <div className={s.sectionCard}>
            <div className={s.sectionHeader}>
              <div className={cx(s.sectionHeaderIcon, s.sectionHeaderIconBlue)}>
                <Landmark size={18} />
              </div>
              <h3 className={s.sectionTitle}>Megasoft Settings</h3>
            </div>
            <div className={s.sectionBody}>
              <div className={s.girdTwo}>
                <div className={s.formGroup}>
                  <label className={s.formLabel}>Merchant ID</label>
                  <Field name="merchentID" component={CommonFormComponent} label={"Merchant ID"} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}>Username</label>
                  <Field name="username" component={CommonFormComponent} label={"Username"} />
                </div>
                <div className={s.formGroup}>
                  <label className={s.formLabel}>Password</label>
                  <Field name="password" type="text" component={CommonFormComponent} label={"Password"} />
                </div>
              </div>
            </div>
          </div>

          {/* Footer Actions */}
          <div className={s.footerActions}>
            <button type="submit" className={s.saveButton} disabled={submitting}>
              {submitting ? <Loader2 size={18} className="spin" /> : <Save size={18} />}
              <FormattedMessage {...messages.save} />
            </button>
          </div>
        </form>
      </div>
    );
  }
}

ConfigSettingsForm = reduxForm({
  form: 'ConfigSettingsForm', // a unique name for this form
  validate
})(ConfigSettingsForm);

export default injectIntl(withStyles(s)(ConfigSettingsForm));

